import { render, staticRenderFns } from "./appointmentEdit.vue?vue&type=template&id=67c83e58&scoped=true&"
import script from "./appointmentEdit.vue?vue&type=script&lang=js&"
export * from "./appointmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./appointmentEdit.vue?vue&type=style&index=0&id=67c83e58&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c83e58",
  null
  
)

export default component.exports